import React from "react";
import Page from "./Routes/Page";
import "./App.css";

export default function App() {
  return (
    <>
      <div className="wrapper">
        <Page />
      </div>
    </>
  );
}
